import { useMutation } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { api } from '.';

export const useSaveInquiry = () => {
	const url = '/front/saveInquiry';
	return useMutation<AxiosResponse, AxiosError, FormData>({
		mutationFn: (data) =>
			api.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}),
	});
};
